import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconGraphBarSvg } from "./IconGraphBarSvg.mjs";
const IconGraphBar = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconGraphBarSvg, ...iconProps });
};
export {
  IconGraphBar
};
